// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_PHOTO = "Opravdu chce\u0161 vymazat fotku?";
export const PHOTO_HAS_BEEN_DELETED = "Fotka byla smaz\u00e1na.";
